import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

export interface PointingAddress {
  id?: number;
  latitude: number;
  longitude: number;
  name: string;
  qrcode?: string;
}

export interface PointingAddressResponse {
  id: number;
  name: string;
  latitude: number;
  longitude: number;
}

export interface CreatePointingAddressRequest {
  latitude: number;
  longitude: number;
  name: string;
  qrcode: string;
}

export interface ProjectDetailsResponse {
  realEstateProperty: {
    id: number;
    name: string;
    qrcode: string;
    // ... other properties
  };
}

@Injectable({
  providedIn: 'root'
})
export class PointingAddressService {
  private endpoints = environment.endpoints;

  constructor(private http: HttpClient) { }

  saveAddress(address: CreatePointingAddressRequest): Observable<PointingAddressResponse> {
    return this.http.post<PointingAddressResponse>(`${this.endpoints.pointingAddresses.create}`, address);
  }

  getAddressById(id: number): Observable<PointingAddressResponse> {
    return this.http.get<PointingAddressResponse>(`${this.endpoints.pointingAddresses.byId.replace('{id}', id.toString())}`);
  }

  /**
   * Récupère les adresses de pointage par propertyId via API Pointage
   */
  getAddressByPropertyId(propertyId: number): Observable<PointingAddressResponse[]> {
    const headers = new HttpHeaders({
      'accept': '*/*',
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });

    console.log('🌐 Récupération adresses de pointage via API Pointage:', `${this.endpoints.pointingAddresses.byProperty.replace('{propertyId}', propertyId.toString())}`);

    return this.http.get<PointingAddressResponse[]>(`${this.endpoints.pointingAddresses.byProperty.replace('{propertyId}', propertyId.toString())}`, { headers });
  }

  updateAddress(id: number, address: CreatePointingAddressRequest): Observable<PointingAddressResponse> {
    return this.http.put<PointingAddressResponse>(`${this.endpoints.pointingAddresses.update.replace('{id}', id.toString())}`, address);
  }

  deleteAddress(id: number): Observable<void> {
    return this.http.delete<void>(`${this.endpoints.pointingAddresses.delete.replace('{id}', id.toString())}`);
  }

  /**
   * Récupère les détails d'un projet incluant son QR code via API Pointage
   */
  getProjectDetails(propertyId: number): Observable<any> {
    const headers = new HttpHeaders({
      'accept': '*/*',
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });

    const url = `${this.endpoints.realestate.details.replace('{id}', propertyId.toString())}`;

    return this.http.get<any>(url, { headers });
  }
}